'use client';

import { usePromptTrigger } from '@/hooks/usePromptTrigger';

interface BuildingPromptTriggerProps {
  buildingSlug: string;
  /**
   * The URL to send the user to after a successful subscription
   * purchase — this building's own report page.
   */
  reportReturnUrl: string;
}

/**
 * Fires the prompt-counter increment for a building page view. Deduped
 * by building slug (same slug = same view). Renders nothing.
 */
export function BuildingPromptTrigger({
  buildingSlug,
  reportReturnUrl,
}: BuildingPromptTriggerProps) {
  usePromptTrigger('building', buildingSlug, reportReturnUrl);
  return null;
}
